<template>
  <header class="main_menu transition_on">

    <!-- HEADER -->
    <div id="menu-segundo">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">

            <div class="row">

              <!-- LOGO -->
              <div class="col-6 blc-menu">
                <router-link to="/dashboard" class="logomenu">
                  <img src="/img/logo-naabsa.png" alt="Logo NAABSA" />
                  <h1 class="sr-only">Naabsa</h1>
                </router-link>
              </div>

              <!-- USER DESKTOP -->
              <div class="col-6 blc-menu blc-segundo desktop transition_off">

                <router-link to="/perfil" class="btn-redondo btn-config">
                  <img src="/img/icon-engrenagem.png" alt="Engrenagem" />
                </router-link>

                <a v-if="user.photo_url" href="#" class="btn-redondo btn-ft-user">
                  <div v-if="isLoading" class="user-img-skeleton"></div>
                  <img v-else-if="user.photo_url" :src="user.photo_url" alt="Usuário" />
                </a>

                <em class="txt">
                  <p>
                    {{ userName }}<br />
                    <span>{{ userRole }}</span>
                  </p>
                  <div class="sub">
                    <a href="#" @click.prevent="logout">Logout</a>
                  </div>
                </em>

              </div>

              <!-- MOBILE BUTTON -->
              <div class="col-6 mobile header-mobile">
                <div
                  class="hamburguer-bt mobile"
                  :class="{ ativo: showMenu }"
                  @click="toggleMenuVisibility"
                >
                  <div class="hamburguer_line hamburguer-top"></div>
                  <div class="hamburguer_line hamburguer-middle"></div>
                  <div class="hamburguer_line hamburguer-bottom"></div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- MOBILE MENU -->
    <div id="opt_menu" class="mobile" :class="{ ativo: showMenu }">
      <div class="menu-lateral transition_on">

        <!-- USER MOBILE -->
        <div class="item-menu user">
          <em class="inf-user txt transition_off">
            <img v-if="user.photo_url" :src="user.photo_url" alt="Foto Usuário" />
            <p>
              {{ user.name }}<br />
              <span>{{ user.role }}</span>
            </p>
            <div class="sub">
              <a href="#" @click.prevent="logout">Logout</a>
            </div>
          </em>

          <div class="btn-info">
            <a href="/perfil" class="btn-redondo btn-config">
              <img src="/img/icon-engrenagem.png" alt="Engrenagem" />
            </a>
          </div>
        </div>

        <router-link to="/dashboard">
          <div class="item-menu">
            <img src="/img/icon-statistics.png" alt="Statistics" />
            <p>Statistics</p>
          </div>
        </router-link>

        <div
          class="item-menu subitens"
          v-if="$root.isAdmin || $root.isBasicAdmin"
          @click="toggleMenu"
        >
          <img src="/img/icon-comm.png" alt="Comm" />
          <p>Comm</p>
          <span>></span>

          <ul>
            <router-link to="/cargas_tipos/adicionar"><li>New</li></router-link>
            <router-link to="/cargas_tipos/listar"><li>List</li></router-link>
          </ul>
        </div>

        <div class="item-menu subitens" @click="toggleMenu">
          <img src="/img/icon-lines.png" alt="Line-ups" />
          <p>Line-ups</p>
          <span>></span>

          <ul>
            <router-link to="/lineups/adicionar" v-if="!$root.isClient">
              <li>New</li>
            </router-link>
            <router-link to="/lineups/listar">
              <li>List</li>
            </router-link>
          </ul>
        </div>

        <div
          class="item-menu subitens"
          v-if="$root.isAdmin || $root.isBasicAdmin"
          @click="toggleMenu"
        >
          <img src="/img/icon-fields.png" alt="Fields of line-ups" />
          <p>Fields of line-ups</p>
          <span>></span>

          <ul>
            <router-link to="/campos/afretadores"><li>Charterers</li></router-link>
            <router-link to="/campos/agencias"><li>Agencies</li></router-link>
            <router-link to="/campos/navios"><li>Vessels</li></router-link>
            <router-link to="/campos/recebedores"><li>Receivers|Shippers</li></router-link>
            <router-link to="/campos/lineup_porto"><li>Ports of destination</li></router-link>
          </ul>
        </div>

        <div
          class="item-menu subitens"
          v-if="$root.isAdmin || $root.isBasicAdmin"
          @click="toggleMenu"
        >
          <img src="/img/icon-ports.png" alt="Ports" />
          <p>Ports</p>
          <span>></span>

          <ul>
            <router-link to="/portos/adicionar"><li>New</li></router-link>
            <router-link to="/portos/listar"><li>List</li></router-link>
          </ul>
        </div>

        <div class="item-menu subitens" v-if="$root.isAdmin" @click="toggleMenu">
          <img src="/img/icon-grups.png" alt="Users" />
          <p>Users</p>
          <span>></span>

          <ul>
            <router-link to="/usuarios/adicionar"><li>New</li></router-link>
            <router-link to="/usuarios/listar"><li>List</li></router-link>
            <router-link to="/usuarios/atividades"><li>Activities</li></router-link>
          </ul>
        </div>

        <div class="item-menu subitens" v-if="$root.isAdmin" @click="toggleMenu">
          <img src="/img/icon-prospects.svg" alt="Prospects" />
          <p>Prospects</p>
          <span>></span>

          <ul>
            <router-link to="/prospects/adicionar"><li>New</li></router-link>
            <router-link to="/prospects/listar"><li>List</li></router-link>
          </ul>
        </div>

        <div class="item-menu subitens" v-if="$root.isAdmin">
          <router-link to="/exportation-logs" class="menu-link-center">
            <img src="/img/icon-lines.png" alt="Logs" />
            <p>Exportation logs</p>
          </router-link>
        </div>

        <div class="item-menu subitens" v-if="$root.isAdmin">
          <router-link to="/email_information" class="menu-link-center">
            <img src="/img/icon-comm.png" alt="Comm" />
            <p>Email Information</p>
          </router-link>
        </div>

      </div>
    </div>

    <div class="fundo_menu" :class="{ ativo: showMenu }"></div>

  </header>
</template>
<script>
export default {
  data() {
    return {
      user: {},
      showMenu: false,
      activeNotifications: false,
      searchQuery: "",
      title: "Profile",
      avatar: null,
    };
  },

  async created() {
    this.watchUser();
    await this.fetchUser();
  },

  computed: {
    profileImage() {
      return this.avatar || "/img/placeholder.jpg";
    },

    user() {
      return this.$store.getters["profile/me"] || null;
    },

    isLoading() {
      return !this.user;
    },

    userName() {
      return this.user && this.user.name ? this.user.name : 'Loading...';
    },

    userRole() {
      return this.user && this.user.role ? this.user.role : '';
    }
  },

  watch: {
    $route() {
      this.hideMenu();
    },
  },

  methods: {
    watchUser() {
      this.$store.watch(
        () => this.$store.getters["profile/me"],
        (me) => {
          this.user = me;
        }
      );
    },

    async fetchUser() {
      await this.$store.dispatch("profile/me");
    },


    toggleMenuVisibility() {
      this.showMenu = !this.showMenu;
    },

    hideMenu() {
      this.showMenu = false;
    },

    toggleMenu(event) {
      let menu = event.target;
      const menus = document.querySelectorAll(".item-menu.subitens");

      while (!menu.classList.contains("subitens")) {
        menu = menu.parentNode;
      }

      const isActive = menu.classList.contains("ativo");

      menus.forEach((m) => m.classList.remove("ativo"));

      if (!isActive) {
        menu.classList.add("ativo");
      }
    },


    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },

    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },


    async logout() {

      try {
        this.$store.dispatch("logout");
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
      }

    },
  },
};
</script>

<style>

.header-mobile {
  height: 85px;
  text-align: right;
}

.menu-link-center {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.sr-only {
  margin: 0;
  z-index: -1;
  font-size: 0;
}

.user-img-skeleton {
  width: 85px;
  height: 85px;
  margin-bottom: 5px;
  border-radius: 100%;
  background: linear-gradient(
    90deg,
    #3f3f3f 25%,
    #ffffff33 50%,
    #3f3f3f 75%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

</style>